import axios from "axios";
import { getApiBaseUrl } from "../config/api";

/** Preview the next auto-assigned Student ID for a class register. */
export async function fetchNextStudentId(classId) {
    if (!classId) return null;
    const base = getApiBaseUrl();
    try {
        const { data } = await axios.get(`${base}/Sclass/${classId}/next-student-id`);
        if (data?.nextStudentId != null) return data;
    } catch {
        /* fall through — older API without next-student-id route */
    }
    try {
        const { data: cls } = await axios.get(`${base}/Sclass/${classId}`);
        const classStudentCount =
            cls?._count?.students ??
            (Array.isArray(cls?.students) ? cls.students.length : 0) ??
            0;
        const nextStudentId = Number(classStudentCount) + 1;
        return { nextStudentId, classStudentCount, enrollmentOrder: nextStudentId };
    } catch {
        return null;
    }
}
